import { LoadableAfterPaint } from '@confluence/loadable';

export const RecentlyUpdatedMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RecentlyUpdatedMacro" */ '../src/RecentlyUpdatedMacroRenderer.tsx'
			)
		).RecentlyUpdatedMacroRendererHandler,
});
